import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash, FaSave, FaTimes, FaPlus, FaSearch } from "react-icons/fa";
import AdminNavbar from "../Layout/AdminNavbar";
import API_BASE_URL from "../config";

const S = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .dg-wrap {
    min-height: 100vh;
    background: #f0f2f8;
    font-family: 'Plus Jakarta Sans', sans-serif;
    padding-top: 108px;
  }

  .dg-banner {
    background: linear-gradient(120deg, #1e1b4b 0%, #3730a3 50%, #4f46e5 100%);
    padding: 36px 48px 80px;
    position: relative;
    overflow: hidden;
  }

  .dg-banner::before {
    content: '';
    position: absolute;
    top: -60px; right: -60px;
    width: 280px; height: 280px;
    border-radius: 50%;
    background: rgba(255,255,255,0.04);
  }

  .dg-banner::after {
    content: '';
    position: absolute;
    bottom: -80px; left: 30%;
    width: 360px; height: 360px;
    border-radius: 50%;
    background: rgba(255,255,255,0.03);
  }

  .dg-banner-title {
    font-size: 28px;
    font-weight: 800;
    color: #fff;
    letter-spacing: -0.6px;
  }

  .dg-banner-sub {
    margin-top: 6px;
    font-size: 14px;
    color: rgba(255,255,255,0.55);
    font-weight: 400;
  }

  .dg-stats-row {
    display: flex;
    gap: 16px;
    margin-top: 24px;
  }

  .dg-stat-pill {
    background: rgba(255,255,255,0.10);
    border: 1px solid rgba(255,255,255,0.14);
    border-radius: 40px;
    padding: 6px 16px;
    font-size: 13px;
    font-weight: 600;
    color: rgba(255,255,255,0.85);
    display: flex;
    align-items: center;
    gap: 7px;
    backdrop-filter: blur(6px);
  }

  .dg-stat-dot {
    width: 7px; height: 7px;
    border-radius: 50%;
    background: #818cf8;
  }

  .dg-body {
    max-width: 1100px;
    margin: -44px auto 0;
    padding: 0 32px 60px;
    position: relative;
    z-index: 2;
  }

  .dg-actionbar {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(30,27,75,0.10);
    padding: 18px 22px;
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 24px;
  }

  .dg-search-wrap {
    flex: 1;
    position: relative;
  }

  .dg-search-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #a5b4fc;
    font-size: 13px;
  }

  .dg-search {
    width: 100%;
    border: 1.5px solid #e8eaf6;
    border-radius: 10px;
    padding: 10px 14px 10px 38px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13.5px;
    color: #1e1b4b;
    background: #f8f8fd;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  .dg-search::placeholder { color: #c7c9e8; }

  .dg-search:focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.12);
    background: #fff;
  }

  .dg-add-row {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .dg-new-input {
    border: 1.5px solid #e8eaf6;
    border-radius: 10px;
    padding: 10px 14px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13.5px;
    color: #1e1b4b;
    background: #f8f8fd;
    outline: none;
    width: 520px;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  .dg-new-input::placeholder { color: #c7c9e8; }

  .dg-new-input:focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.12);
    background: #fff;
  }

  .dg-btn-add {
    background: #4f46e5;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 7px;
    white-space: nowrap;
    box-shadow: 0 3px 12px rgba(79,70,229,0.35);
    transition: all 0.18s;
  }

  .dg-btn-add:hover {
    background: #4338ca;
    box-shadow: 0 5px 18px rgba(79,70,229,0.45);
    transform: translateY(-1px);
  }

  .dg-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
    gap: 16px;
  }

  .dg-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(30,27,75,0.07);
    padding: 22px 20px 18px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    border: 1.5px solid transparent;
    transition: box-shadow 0.2s, border-color 0.2s, transform 0.2s;
    animation: cardIn 0.3s ease both;
  }

  @keyframes cardIn {
    from { opacity: 0; transform: translateY(10px) scale(0.98); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }

  .dg-card:hover {
    box-shadow: 0 8px 28px rgba(79,70,229,0.13);
    border-color: #e0e1ff;
    transform: translateY(-2px);
  }

  .dg-card.editing {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.12);
  }

  .dg-card-icon {
    width: 46px;
    height: 46px;
    border-radius: 12px;
    background: linear-gradient(135deg, #eef2ff, #e0e7ff);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 800;
    color: #4f46e5;
    letter-spacing: -1px;
    flex-shrink: 0;
  }

  .dg-card-name {
    font-size: 15px;
    font-weight: 700;
    color: #1e1b4b;
    line-height: 1.3;
    flex: 1;
  }

  .dg-card-edit-input {
    width: 100%;
    border: 1.5px solid #6366f1;
    border-radius: 8px;
    padding: 8px 11px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13.5px;
    font-weight: 600;
    color: #1e1b4b;
    outline: none;
    box-shadow: 0 0 0 3px rgba(99,102,241,0.1);
  }

  .dg-card-footer {
    display: flex;
    gap: 8px;
    padding-top: 10px;
    border-top: 1px solid #f0f1fb;
  }

  .dg-card-btn {
    flex: 1;
    border: none;
    border-radius: 8px;
    padding: 8px 0;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    transition: all 0.15s;
  }

  .dg-card-btn.edit-btn  { background: #f0f1ff; color: #4f46e5; }
  .dg-card-btn.edit-btn:hover  { background: #e0e3ff; }
  .dg-card-btn.del-btn   { background: #fff1f1; color: #ef4444; }
  .dg-card-btn.del-btn:hover   { background: #ffe0e0; }
  .dg-card-btn.save-btn  { background: #4f46e5; color: #fff; box-shadow: 0 2px 8px rgba(79,70,229,0.3); }
  .dg-card-btn.save-btn:hover  { background: #4338ca; }
  .dg-card-btn.cancel-btn { background: #f3f4f6; color: #6b7280; }
  .dg-card-btn.cancel-btn:hover { background: #e5e7eb; }

  .dg-empty {
    grid-column: 1 / -1;
    padding: 72px 0;
    text-align: center;
  }

  .dg-empty-emoji { font-size: 48px; margin-bottom: 14px; }
  .dg-empty-txt { font-size: 15px; font-weight: 600; color: #818cf8; }
  .dg-empty-sub { font-size: 13px; color: #c7c9e8; margin-top: 4px; }

  .dg-section-label {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: #a5b4fc;
    margin-bottom: 14px;
  }

  @media (max-width: 640px) {
    .dg-banner { padding: 28px 20px 70px; }
    .dg-body { padding: 0 14px 40px; }
    .dg-actionbar { flex-direction: column; align-items: stretch; }
    .dg-add-row { flex-direction: column; }
    .dg-new-input { width: 100%; }
    .dg-banner-title { font-size: 22px; }
  }
`;

export default function DesignationCRUD() {
  const [designations, setDesignations] = useState([]);
  const [newDesignation, setNewDesignation] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const fetchDesignations = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/designations/all`, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      });
      if (!res.ok) throw new Error("Failed to fetch");
      setDesignations(await res.json());
    } catch (error) {
      toast.error("Failed to load designations");
      console.error("Designation fetch error:", error);
    }
  };

  useEffect(() => { fetchDesignations(); }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    if (!token) { toast.error("You must be logged in to access this page."); navigate("/"); return; }
    if (!roles.includes("ROLE_ADMIN")) { toast.error("You are not authorized to access this page."); navigate("/"); }
  }, [navigate]);

  const handleAdd = async () => {
    if (!newDesignation.trim()) { toast.warning("Please enter a designation name."); return; }
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/designations/add`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ name: newDesignation }),
      });
      if (!res.ok) throw new Error("Add failed");
      toast.success("Designation added successfully!");
      setNewDesignation("");
      fetchDesignations();
    } catch (err) {
      toast.error("Failed to add designation.");
      console.error("Add error:", err);
    }
  };

  const handleUpdate = async (id) => {
    if (!editName.trim()) { toast.warning("Please enter a valid name."); return; }
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/designations/update/${id}`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ name: editName }),
      });
      if (!res.ok) throw new Error("Update failed");
      toast.success("Designation updated!");
      setEditingId(null);
      fetchDesignations();
    } catch (err) {
      toast.error("Failed to update designation.");
      console.error("Update error:", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this designation?")) return;
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/designations/delete/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      });
      if (!res.ok) throw new Error("Delete failed");
      toast.success("Designation deleted.");
      fetchDesignations();
    } catch (err) {
      toast.error("Failed to delete designation.");
      console.error("Delete error:", err);
    }
  };

  const initials = (name) => name ? name.slice(0, 2).toUpperCase() : "??";
  const filtered = designations.filter(d =>
    d.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <style>{S}</style>

      <div style={{ position: "fixed", top: 0, left: 0, width: "100%", zIndex: 1000 }}>
        <AdminNavbar />
      </div>

      <div className="dg-wrap">
        <div className="dg-banner">
          <div className="dg-banner-title">Designation Management</div>
          <div className="dg-banner-sub">Define and manage all job designations across the organization</div>
          <div className="dg-stats-row">
            <div className="dg-stat-pill">
              <span className="dg-stat-dot" />
              {designations.length} Designations
            </div>
            {search && (
              <div className="dg-stat-pill">
                <span className="dg-stat-dot" style={{ background: "#fbbf24" }} />
                {filtered.length} Results
              </div>
            )}
          </div>
        </div>

        <div className="dg-body">
          <div className="dg-actionbar">
            <div className="dg-search-wrap">
              <FaSearch className="dg-search-icon" />
              <input
                className="dg-search"
                placeholder="Search designations…"
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
            <div className="dg-add-row">
              <input
                className="dg-new-input"
                placeholder="New designation name…"
                value={newDesignation}
                onChange={e => setNewDesignation(e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleAdd()}
              />
              <button className="dg-btn-add" onClick={handleAdd}>
                <FaPlus size={11} /> Add
              </button>
            </div>
          </div>

          <div className="dg-section-label">All Designations</div>
          <div className="dg-grid">
            {filtered.length === 0 && (
              <div className="dg-empty">
                <div className="dg-empty-emoji">🪪</div>
                <div className="dg-empty-txt">No designations found</div>
                <div className="dg-empty-sub">Try a different search or add one above</div>
              </div>
            )}

            {filtered.map((d) => (
              <div key={d.id} className={`dg-card${editingId === d.id ? " editing" : ""}`}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div className="dg-card-icon">{initials(d.name)}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    {editingId === d.id ? (
                      <input
                        className="dg-card-edit-input"
                        value={editName}
                        onChange={e => setEditName(e.target.value)}
                        onKeyDown={e => {
                          if (e.key === "Enter") handleUpdate(d.id);
                          if (e.key === "Escape") setEditingId(null);
                        }}
                        autoFocus
                      />
                    ) : (
                      <div className="dg-card-name">{d.name}</div>
                    )}
                  </div>
                </div>

                <div className="dg-card-footer">
                  {editingId === d.id ? (
                    <>
                      <button className="dg-card-btn save-btn" onClick={() => handleUpdate(d.id)}>
                        <FaSave size={10} /> Save
                      </button>
                      <button className="dg-card-btn cancel-btn" onClick={() => setEditingId(null)}>
                        <FaTimes size={10} /> Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button className="dg-card-btn edit-btn"
                        onClick={() => { setEditingId(d.id); setEditName(d.name); }}>
                        <FaEdit size={10} /> Edit
                      </button>
                      <button className="dg-card-btn del-btn" onClick={() => handleDelete(d.id)}>
                        <FaTrash size={10} /> Delete
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}